module.exports = __webpack_public_path__ + "static/media/pexels-anthony-shkraba-5467495.627e9421.jpg";